import { render } from "./StickyNav.vue?vue&type=template&id=5d6a3188&scoped=true"
import script from "./StickyNav.vue?vue&type=script&lang=js"
export * from "./StickyNav.vue?vue&type=script&lang=js"

import "./StickyNav.vue?vue&type=style&index=0&id=5d6a3188&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d6a3188"]])

export default __exports__